import { InViewport } from '@gik/core/components/InViewport';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';
import { ErrorPageSection } from '@gik/core/pages/Error/ErrorPageSection';
import routes from '@gik/core/routes';
import { useEnvStore } from '@gik/core/store/EnvStore';
import { useUserStore } from '@gik/core/store/UserStore';
import bemBlock from '@gik/core/utils/bemBlock';
import { navigateTo } from '@gik/core/utils/navigateTo';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import { LayoutAside } from '@gik/ui-legacy/LayoutAside';
import ClaimedItems from '@gik/user-profile/components/ClaimedItems/ClaimedItems';
import { UserPagesSection } from '@gik/user-profile/components/UserPages/UserPagesSection';
import { UserSettings } from '@gik/user-profile/components/UserSettings/UserSettings';
import React from 'react';
import { useUserWallets } from '../../hooks/useUserWallets';
import { SavedArticlesSection } from '../SavedArticles/SavedArticlesSection';
import { SavedProductsSection } from '../SavedProducts/SavedProductsSection';
import { UserGroupsSection } from '../UserGroups/UserGroupsSection';
import { UserWalletsSection } from '../UserWallets/UserWalletsSection';

const blockName = 'user-profile';

function UserProfileComp() {
  const bem = bemBlock(blockName);
  const isMd = useBreakpoint(Breakpoint.MD);
  const { id: userId } = useUserStore(state => ({
    id: state.id,
  }));

  const { data: wallets, error } = useUserWallets(useEnvStore.getState().WALLET_ENABLED ? userId : undefined);

  React.useEffect(() => {
    if (!userId) {
      navigateTo(routes.home);
    }
  }, [userId]);

  if (isMd) {
    return (
      <div className={bem()}>
        <div className={bem('wrapper')}>
          <LayoutAside className={bem()}>
            <aside>
              <InViewport height={500}>
                <UserSettings />
              </InViewport>
              <InViewport height={300}>
                <SavedArticlesSection />
              </InViewport>
              <InViewport height={300}>
                <SavedProductsSection />
              </InViewport>
            </aside>
            <main>
              <div className="tw-flex tw-gap-4">
                {wallets?.length > 0 && <UserWalletsSection />}

                <UserGroupsSection />
              </div>
              <InViewport height={600}>
                <UserPagesSection />
              </InViewport>
              <InViewport height={322}>
                <ClaimedItems />
              </InViewport>
            </main>
          </LayoutAside>
        </div>
      </div>
    );
  }

  return (
    <div className={bem()}>
      <section className={bem('mobile-panel')}>
        <InViewport height={500}>
          <UserSettings />
        </InViewport>

        <div className="tw-flex-col tw-gap-4">
          {wallets?.length > 0 && <UserWalletsSection />}
        </div>
        <InViewport height={400}>
          <UserPagesSection />
        </InViewport>

        <UserGroupsSection />
        <InViewport height={322}>
          <ClaimedItems />
        </InViewport>
        <InViewport height={300}>
          <SavedArticlesSection />
        </InViewport>
        <InViewport height={300}>
          <SavedProductsSection />
        </InViewport>
      </section>
    </div>
  );
}

export const UserProfile = withComponentErrorBoundary(UserProfileComp, {
  ErrorFallback: ErrorPageSection,
});
